/**
 * Service to fetch parent profile data from the backend
 */
import { supabase } from './supabase';
import { getApiUrl } from './apiConfig';

export const fetchParentProfile = async (userId) => {
  try {
    // Get the current Supabase session to get JWT token
    const { data: { session }, error: sessionError } = await supabase.auth.getSession();
    
    if (sessionError || !session?.access_token) {
      console.error('No valid session found:', sessionError);
      return null;
    }
    
    console.log('🔐 Using JWT token for parent profile request');
    
    const response = await fetch(getApiUrl(`parent-profiles?user_id=${userId}`), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${session.access_token}`
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    console.log('✅ Parent profile data received:', data);
    return data;
  } catch (error) {
    console.error('Error fetching parent profile:', error);
    return null;
  }
};
